/* eslint-disable react-hooks/exhaustive-deps */
import { showToast, } from "@libs/useful"
import { __ } from "@libs/utilities"
import { IState, useMainStore } from "@/settings/zustand"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

/* Protopia Ecosystem component */
export interface IStorageManagerProps {
   
}
const StorageManager = (props: IStorageManagerProps): JSX.Element => {
    const [URLSearchParams, SetURLSearchParams] = useSearchParams()
    const version = useMainStore((state:IState) => state.version)
    useEffect(() => { 
        getLocal()
    }, [])
    const getLocal = async () => {
        const storage = URLSearchParams.get( "strg" )
        if( storage === "clear" ) {
            localStorage.clear();
            showToast({
                message: __( "All local data cleared" )
            })
        } 
        if( storage === "ver" ) { 
            showToast({
                message: __( "Current version:" ) + version
            })
        }
    }
    return <></>
}
export default StorageManager